/* ============================================================
   Custom Two Image Link Blocks — mobile swipe carousel
   Pairs with: sections/custom-two-image-link-blocks.liquid

   Only does anything when the section uses the "carousel" mobile
   layout AND the viewport is mobile (<= 749px). On desktop and in
   the "stacked" layout it stays out of the way.

   Responsibilities:
   - Sync the active dot with the scroll position.
   - Scroll to a slide when its dot is clicked.
   - Allow mouse/trackpad click-drag (touch already scrolls
     natively) so it can be driven in the Shopify theme editor.
   ============================================================ */
(function () {
  var MOBILE = '(max-width: 749px)';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSection(section) {
    if (!section) return;

    var track = section.querySelector('[data-ctil-track]');
    if (!track || track.dataset.ctilReady) return;

    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-ctil-slide]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-ctil-dot]'));
    if (slides.length < 2) return;

    track.dataset.ctilReady = '1';

    function isCarousel() {
      return (
        section.classList.contains('ctil--mobile-carousel') &&
        window.matchMedia(MOBILE).matches
      );
    }

    // Distance between two consecutive slides (card width + gap).
    function stepSize() {
      var step = slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
      return step > 0 ? step : track.clientWidth;
    }

    function currentIndex() {
      var index = Math.round(track.scrollLeft / stepSize());
      return Math.max(0, Math.min(index, slides.length - 1));
    }

    function setActive(index) {
      for (var i = 0; i < dots.length; i++) {
        var active = i === index;
        dots[i].classList.toggle('is-active', active);
        if (active) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    // Keep the dots in sync with native scrolling (throttled to a frame).
    var frame = null;
    track.addEventListener(
      'scroll',
      function () {
        if (!isCarousel() || frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          setActive(currentIndex());
        });
      },
      { passive: true }
    );

    // Dot click -> scroll that slide into the centre.
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (!isCarousel()) return;
        track.scrollTo({
          left: index * stepSize(),
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      });
    });

    // Mouse / trackpad drag-to-scroll (touch uses the native scroll).
    var dragging = false;
    var dragged = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (event) {
      if (!isCarousel() || event.pointerType !== 'mouse') return;
      dragging = true;
      dragged = false;
      startX = event.clientX;
      startScroll = track.scrollLeft;
    });

    window.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 3) dragged = true;
      track.scrollLeft = startScroll - delta;
    });

    window.addEventListener('pointerup', function () {
      dragging = false;
    });

    // Swallow the click that ends a drag so it doesn't open a product.
    track.addEventListener(
      'click',
      function (event) {
        if (dragged) {
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }
      },
      true
    );

    window.addEventListener('resize', function () {
      if (isCarousel()) setActive(currentIndex());
    });

    setActive(currentIndex());
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('[data-ctil]');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  // Shopify theme editor: re-init when a section is added / reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
